import draftActions from './draft-actions';

export default {
    setLongDescription: (longDescription) => (dispatch) => {
        dispatch({
            type: 'SET_LONG_DESCRIPTION',
            payload: longDescription
        });
        dispatch(draftActions.updateDraftCanBeResumed());
    },
    setLongDescriptionFromDraft: (longDescription) => (dispatch) => {
        dispatch({
            type: 'SET_LONG_DESCRIPTION_FROM_DRAFT',
            payload: longDescription
        });
        dispatch(draftActions.updateDraftCanBeResumed());
    },
    reset: () => (dispatch) => {
        dispatch({
            type: 'RESET_LONG_DESCRIPTION'
        });
        dispatch(draftActions.updateDraftCanBeResumed());
    }
};
